import React from 'react';
import { ChevronLeft, PlusIcon, X } from "lucide-react";
import botIcon from "../../assets/iconChat.png";

interface HeaderChatProps {
    closeChat: () => void;
    closeWidget: () => void;
    startNewChat: () => void;
    brandName?: string;
}

const HeaderChat = ({ closeChat, closeWidget, startNewChat, brandName = "RMT-AI" }: HeaderChatProps) => {
    return (
        <div className="chat-header">
            <div className="chat-header-left">
                <button className="btn-back-chat" onClick={() => closeChat()} aria-label="Go back">
                    <ChevronLeft size={20} />
                </button>
                <div className="chat-header-info">
                    <div className="chat-header-avatar">
                        <img src={botIcon} alt="RMT-AI" />
                        <span className="online-dot"></span>
                    </div>
                    <div className="chat-header-text">
                        <span className="chat-header-name">{brandName}</span>
                        <span className="chat-header-status">Online</span>
                    </div>
                </div>
            </div>
            <div className="chat-header-right">
                <button
                    className="btn-new-chat"
                    onClick={startNewChat}
                    aria-label="Start new chat"
                >
                    <PlusIcon size={16} />
                    <span>New Chat</span>
                </button>
                <button
                    className="btn-close-mobile"
                    onClick={() => { closeChat(); closeWidget(); }}
                    aria-label="Close widget"
                >
                    <X size={20} />
                </button>
            </div>
        </div>
    );
};

export default HeaderChat;
